import "./StatutoryHolidayStatusDataTable.css"

import { FC, useEffect, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import {
	StatutoryHolidayProfileListheaderColumns,
} from "../../CompanyStatutoryHolidaySetup";
import { formatDateToShow } from "../../../../common/Common";
import { useTheme } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";

interface IStatutoryHolidayProfileListStatusDataTable {
	statutoryHolidayProfileListUpdatedData: (data: any) => void;
	statutoryHolidayProfileListStatusHeader: string;
	statutoryHolidayProfileListDataItems: any
	onStatusChangeClickedHandler: (rowData: any) => void;
}
export const StatutoryHolidayProfileListStatusDataTable: FC<IStatutoryHolidayProfileListStatusDataTable> = ({
	statutoryHolidayProfileListUpdatedData,
	statutoryHolidayProfileListStatusHeader,
	statutoryHolidayProfileListDataItems,
	onStatusChangeClickedHandler,
}) => {
	const theme = useTheme();
	const [statutoryHolidayProfileList, setStatutoryHolidayProfileList] = useState<any>(statutoryHolidayProfileListDataItems);

	useEffect(() => {
		statutoryHolidayProfileListUpdatedData(statutoryHolidayProfileList);
	}, [statutoryHolidayProfileList]);

	
	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					// justifyContent:showGlobalSearch ? "space-between" : "end",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<div
					style={{
						fontSize: "1.5rem",
						fontWeight: "bold",
						fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
					}}
				>
					{statutoryHolidayProfileListStatusHeader}
				</div>

				<span
					className="p-input-icon-left w-3"
					style={{ display: "flex", marginLeft: "auto", height: "37px" }}
				>
				</span>
			</div>
		);
	};
	const headerSearch = renderHeader();

	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		setStatutoryHolidayProfileList((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};

	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		return "p-component p-filled input-dropdown-fields";
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "status") {
			return (
				// <Dropdown
				// 	options={[{ label: "Active", value: 100 }, { label: "In-Active", value: 200 }]}
				// 	value={rowData.status}
				// 	onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
				// 	// placeholder="--"
				// 	className={renderErrorClass(x, row.rowIndex, rowData)}
				// 	optionLabel="label"
				// 	optionValue="value"
				// />
				<EnhancedButtonPrimeReact
					label={
						rowData.status === 100
							? "Active"
							: rowData.status === 200
								? "Disabled"
								: "--"
					}
					raised
					severity={
						rowData.status === 100
							? EnhancedButtonPrimeReactSeverity.Success
							: EnhancedButtonPrimeReactSeverity.Danger
					}
					onClickHandler={() => onStatusChangeClickedHandler(rowData)}

				/>
			);
		} else if (x.field === "holidayDate") {
			return (
				<span>{formatDateToShow(rowData[x.field])}</span>
			);
		} else {
			return (
				<span>{rowData[x.field]}</span>
			);
		}
	};



	return (
		<>
			<div className="card">
				<DataTable
					value={statutoryHolidayProfileList}
					dataKey="id"
					showGridlines
					className="StatutoryHolidayProfileListStatusTableStyle"
					editMode="cell"
					resizableColumns
					columnResizeMode="expand"
					scrollable
					// // reorderableColumns
					filterDisplay="menu"
					scrollHeight="516px"
					header={headerSearch}
				>
					{statutoryHolidayProfileList && statutoryHolidayProfileList.length ? (
						<Column
							header="#"
							className="indexColumn"
							headerClassName="indexColumn"
							headerStyle={{ width: "24px" }}
							frozen
							body={(data, options) => options.rowIndex + 1}
						></Column>
					) : undefined}
					{StatutoryHolidayProfileListheaderColumns.map((x: any, index: any) => {
						return (
							<Column
								key={index}
								field={x.field}
								header={x.headerName}
								headerTooltip={x.description}
								align={x.align}
								alignHeader={x.headerAlign}
								frozen={x.frozenColumn}
								columnKey={x.field}
								style={{
									width: x.minWidth,
									fontSize: "0.875rem",
								}}
								footer={x.footer}
								body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
							/>
						);
					})}
				</DataTable>
			</div>
		</>
	);
};
